<template>
  <div>
    <div class="h-100">
      <b-row class="h-100 no-gutters">
        <b-col lg="4" class="d-lg-block">
          <div class="slider-light">
            <slick ref="slick" :options="slickOptions">
              <div
                class="position-relative vh-100 d-flex justify-content-center align-items-center bg-plum-plate"
              >
                <div class="slide-img-bg" />
                <div class="slider-content text-light">
                  <h3>Validación</h3>
                  <p>Los comprobantes de gastos se validan automáticamente ante el SAT.</p>
                </div>
              </div>
              <div
                class="position-relative vh-100 d-flex justify-content-center align-items-center bg-premium-dark"
              >
                <div class="slide-img-bg" />
                <div class="slider-content text-light">
                  <h3>Reportes automáticos</h3>
                  <p>
                    Su reporte de gastos se genera automáticamente y se pueden filtrar por tipo de gasto, oficina, sucursal o proyecto. No mas papeleo ni captura manual.
                  </p>
                </div>
              </div>
              <div
                class="position-relative vh-100 d-flex justify-content-center align-items-center bg-sunny-morning"
              >
                <div class="slide-img-bg opacity-6" />
                <div class="slider-content text-light">
                  <h3>Carga Automática</h3>
                  <p>Cargue los datos de su factura con tan solo escanear el código QR</p>
                </div>
              </div>
            </slick>
          </div>
        </b-col>
        <b-col
          lg="8"
          md="12"
          class="vh-100 d-flex bg-white justify-content-center align-items-center"
        >
          <b-col lg="6" md="8" sm="12" class="mx-auto app-login-box">
            <b-row align-h="center">
              <img src="../assets/login/logo_intekel.png" height="150px" />
            </b-row>
            <h4>
              <div>{{ $t('login.forgotYourPasswordQuestion') }}</div>
              <span>{{ $t('login.useTheFormBelow') }}</span>
            </h4>
            <div class="divider" />
            <div>
              <Form>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <b-row form>
                    <b-col md="12">
                      <v-text-field
                        color="primary"
                        @keyup.enter="validate"
                        v-model="email"
                        :rules="rules.email"
                        required
                        prepend-icon="person"
                        name="Email"
                        :label="$t('general.email')"
                        :error-messages="errors.email"
                        type="text"></v-text-field>
                    </b-col>
                  </b-row>
                  <div class="mt-4 d-flex align-items-center">
                    <h6 class="mb-0">
                      <a href="#" @click="$router.push('login')" class="text-primary">
                        {{ $t('login.signInExistingAccount') }}
                      </a>
                    </h6>
                    <div class="ml-auto">
                      <v-btn
                        @click="validate"
                        :loading="loading"
                        :disabled="loading"
                        color="primary"
                      >{{ $t('login.recoverPassword') }}</v-btn>
                    </div>
                  </div>
                </v-form>
              </Form>
            </div>
          </b-col>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'
export default {
  components: {
    Slick
  },
  data () {
    return {
      valid: true,
      email: null,
      loading: false,
      errors: {},
      slickOptions: {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        initialSlide: 0,
        autoplay: true,
        adaptiveHeight: true
      },
      slide: 0,
      sliding: null
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    }
  },
  methods: {
    handleClick (newTab) {
      this.currentTab = newTab
    },
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    validate () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        this.resetPassword()
      }
    },
    resetPassword () {
      this.$emit('resetPassword', {
        email: this.email,
        context: this
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forgotPassword.component.vue